'use client';

import { Dialog, DialogContent, DialogDescription } from '@/src/components/ui/dialog';
import useNavigation from '@/src/lib/hooks/useNavigation';
import { DialogTitle } from '@radix-ui/react-dialog';
import { useSearchParams } from 'next/navigation';
import RenderClientProductDetails from '../../stores/[store]/[storeId]/product/components/RenderClientProductDetails';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/src/components/ui/drawer';
import { useMediaQuery } from '@/src/lib/hooks/useMediaQuery';

export function Modal() {
  const params = useSearchParams();
  const { removeQueryString } = useNavigation({ justUpdateUrl: true });
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const isHasProductId = params.get('productId') !== null;
  const isHasStoreId = params.get('storeId') !== null;

  const productId = params.get('productId') || null;
  const storeId = params.get('storeId') || null;

  const openModal = isHasProductId && isHasStoreId;

  const handleClose = () => {
    removeQueryString(['productId', 'storeId']);
  };

  if (!openModal) return null;

  return isDesktop ? (
    <Dialog open={openModal} onOpenChange={handleClose}>
      <DialogContent className="max-h-[85vh] place-items-center overflow-hidden 2xl:max-w-5xl">
        <div className="h-full w-full overflow-y-auto">
          <DialogTitle />
          <DialogDescription />
          <RenderClientProductDetails productId={productId} storeId={storeId} />
        </div>
      </DialogContent>
    </Dialog>
  ) : (
    <Drawer open={openModal} onClose={handleClose}>
      <DrawerContent className="min-h-[70vh]">
        <DrawerHeader className="hidden text-left">
          <DrawerTitle />
        </DrawerHeader>
        <DrawerDescription />
        <div className="h-[70vh] overflow-y-auto">
          <RenderClientProductDetails productId={productId} storeId={storeId} />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
